import React from 'react';
import styled from 'styled-components';
import SidebarTop from './SidebarTop';
import SidebarBottom from './SidebarBottom';
import { BREAK_POINTS } from '../../../../constants/common/breakpoints';

interface LayoutProps {
    children: React.ReactNode;
    totalRXCUI: number;
}

const TopContainer = styled.div`
    max-width: 1400px;
    background-color: ${({ theme }) => theme.gray11};
    margin: auto;
    margin-top: 20px;
    padding: 0px 20px;
    min-height: calc(100vh - 420px);
`;

const StyledContainer = styled.div`
    max-width: 1400px;
    background-color: ${({ theme }) => theme.gray11};
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    min-height: calc(100vh - 420px);
    width: '100%';
    @media (max-width: ${BREAK_POINTS.sm}) {
        display: block;
        margin-top: 0;
    }
`;

const StyledRightPanel = styled.div`
    width: 74%;
    margin-left: 25px;
    flex-grow: 1;
    @media (max-width: ${BREAK_POINTS.sm}) {
        width: 100%;
        margin-left: 0;
        margin-top: 20px;
    }
`;

const Layout: React.FC<LayoutProps> = ({ children, totalRXCUI }) => {

    return (
        <>
            <TopContainer data-testid="manage-drugs-layout">
                <SidebarTop totalRXCUI={totalRXCUI}/>
                <StyledContainer>
                    <SidebarBottom />
                    <StyledRightPanel>
                        {children}
                    </StyledRightPanel>
                </StyledContainer>
            </TopContainer>
        </>
    );
};

export default Layout;